import { render } from "./ModalPdf.vue?vue&type=template&id=e0aa41e0"
import script from "./ModalPdf.vue?vue&type=script&lang=js"
export * from "./ModalPdf.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lucas/Documents/repo/tiototo-users-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__